import {_RequestEnvelope} from '../core/types';
import {AdminDetails} from '../models/admin';

// ---------------------------------------------------------------------------
// LoginWithPassword
// ---------------------------------------------------------------------------

export interface LoginWithPasswordRequest {
    Login: string;
    Password: string;
}

export const LoginWithPasswordResultCode = {
    Unknown: 'Unknown',
    Ok: 'Ok',
    WrongLogin: 'WrongLogin',
    WrongPassword: 'WrongPassword',
} as const;
export type LoginWithPasswordResult =
    typeof LoginWithPasswordResultCode[keyof typeof LoginWithPasswordResultCode];

export type LoginWithPasswordResponse =
    | {
    Result: 'Ok';
    ResultDescription: string;
    AuthToken: string;
    RefreshToken: string;
    Admin: AdminDetails;
}
    | {
    Result: 'Unknown' | 'WrongLogin' | 'WrongPassword';
    ResultDescription: string;
    AuthToken: null;
    RefreshToken: null;
    Admin: null;
};

const _loginWithPasswordMap: Record<number, string> = {
    0: 'Unknown',
    1: 'Ok',
    2: 'WrongLogin',
    3: 'WrongPassword',
};

export function loginWithPassword(
    params: LoginWithPasswordRequest
): _RequestEnvelope<LoginWithPasswordResponse> {
    return {...params, _endpoint: 'admin/auth/loginWithPassword', _resultCodeMap: _loginWithPasswordMap};
}

// ---------------------------------------------------------------------------
// Logout
// ---------------------------------------------------------------------------

export interface LogoutResponse {
    _empty?: never;
}

export function logout(): _RequestEnvelope<LogoutResponse> {
    return {_endpoint: 'admin/auth/logout', _resultCodeMap: null};
}

// ---------------------------------------------------------------------------
// Me
// ---------------------------------------------------------------------------

export interface MeResponse {
    Admin: AdminDetails;
}

export function me(): _RequestEnvelope<MeResponse> {
    return {_endpoint: 'admin/auth/me', _resultCodeMap: null};
}

// ---------------------------------------------------------------------------
// RefreshAuthToken
// ---------------------------------------------------------------------------

export interface RefreshAuthTokenRequest {
    RefreshToken: string;
}

export const RefreshAuthTokenResultCode = {
    Unknown: 'Unknown',
    Ok: 'Ok',
    InvalidToken: 'InvalidToken',
    SessionClosed: 'SessionClosed',
} as const;
export type RefreshAuthTokenResult =
    typeof RefreshAuthTokenResultCode[keyof typeof RefreshAuthTokenResultCode];

export type RefreshAuthTokenResponse =
    | {
    Result: 'Ok';
    ResultDescription: string;
    AuthToken: string;
    RefreshToken: string;
}
    | {
    Result: 'Unknown' | 'InvalidToken' | 'SessionClosed';
    ResultDescription: string;
    AuthToken: null;
    RefreshToken: null;
};

const _refreshAuthTokenMap: Record<number, string> = {
    0: 'Unknown',
    1: 'Ok',
    2: 'InvalidToken',
    3: 'SessionClosed',
};

export function refreshAuthToken(
    params: RefreshAuthTokenRequest
): _RequestEnvelope<RefreshAuthTokenResponse> {
    return {...params, _endpoint: 'admin/auth/refreshAuthToken', _resultCodeMap: _refreshAuthTokenMap};
}
